import React from 'react'
import { Box, Typography, TextField } from '@material-ui/core'
import dayjs from 'dayjs'
import { makeStyles } from '@material-ui/core/styles'
import PoolSelector from 'components/PoolSelector'
import { weiToNum } from 'toolbelt'
import { useAppState } from 'state'
import { usePaladin } from 'hooks'
import { fromWei } from 'web3-utils'

import BorrowButton from 'components/Buttons/BorrowButton'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '40%',
    margin: 'auto',
    border: '1px solid #A5A5A5',
    borderRadius: '4px',
    marginTop: '5rem',
  },
  form: {
    width: '65%',
    margin: 'auto',
    marginTop: '3.5rem',
    marginBottom: '1.5rem',
  },
  label: {
    marginTop: '2rem',
    marginBottom: '.5rem',
  },
  votingPower: {
    display: 'flex',
    flexDirection: 'row',
  },
  votingInput: {
    width: '205px',
    height: '35px',
  },
  max: {
    marginLeft: '1rem',
    alignSelf: 'center',
    color: '#A5A5A5',
    fontSize: 14,
    cursor: 'pointer',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
    color: '#A5A5A5',
  },
  fee: {
    width: '70%',
  },
  feeInput: {
    width: '100%',
  },
  feeBalance: {
    display: 'flex',
    justifyContent: 'flex-start',
    marginTop: '.2rem',
  },
  feeInfoTitle: {
    color: '#A5A5A5',
    fontSize: 12,
  },
  feeInfo: {
    color: '#A5A5A5',
    fontSize: 12,
    marginLeft: '1rem',
  },
  borrow: {
    margin: 'auto',
    marginTop: '2rem',
    marginBottom: '1rem',
    display: 'flex',
    justifyContent: 'center',
  },
  calendar: {
    color: 'red',
  },
}))

const BorrowTab = () => {
  const styles = useStyles()
  const { aaveBalance, underlyingBalance } = useAppState()
  const { borrow, calculateFee } = usePaladin()
  const [date, setDate] = React.useState(dayjs().add(2, 'week').format('YYYY-MM-DD'))
  const [votingPower, setVotingPower] = React.useState('')
  const [fee, setFee] = React.useState('')
  const maxString = underlyingBalance ? `(${weiToNum(underlyingBalance)} AAVE)` : ''

  React.useEffect(() => {
    if (votingPower && date) {
      const fee = calculateFee(votingPower, date)
      if (fee) setFee(fee)
    }
  }, [date, votingPower, calculateFee])

  return (
    <Box>
      <PoolSelector isBorrow={true} />
      <Typography className={styles.label}>Voting Power</Typography>
      <Box className={styles.votingPower}>
        <input
          className={styles.votingInput}
          value={votingPower}
          onChange={(e) => setVotingPower(e.target.value)}
        ></input>
        <Typography className={styles.max}>Max {maxString}</Typography>
      </Box>
      <Typography className={styles.label}>Termination Date</Typography>
      <TextField type="date" value={date} className={styles.calendar} onChange={(e) => setDate(e.target.value)} />
      <Typography className={styles.label}>Fee</Typography>
      <Box className={styles.fee}>
        <input
          className={styles.votingInput}
          value={fee ? parseFloat(fromWei(fee)).toFixed(3) : ''}
          onChange={() => {}}
        />
        <Box className={styles.feeBalance}>
          <Typography className={styles.feeInfoTitle}>Wallet Balance</Typography>
          <Typography className={styles.feeInfo}>{weiToNum(aaveBalance)} AAVE</Typography>
        </Box>
      </Box>
      <Box className={styles.borrow}>
        <BorrowButton
          onClick={() => {
            borrow(votingPower, fee)
          }}
        >
          Borrow
        </BorrowButton>
      </Box>
    </Box>
  )
}

export default BorrowTab
